import React, { Component } from "react";
import service from "../../core/service";
import { fixNumbers } from "../../core/utils";
import * as yup from "yup";
import { toast } from "react-toastify";
import routes from "../../core/routes";

interface IProps {
  dispatch?: any;
  userData?: any;
  dashboardData:any;
}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any;
  value: string;
  openModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  clickLoading: boolean;
  shareList: any;
  page: number;
  price: any;
  title: any;
  to_date: any;
  number: any;
  plan_type: string;
  shareHolder: any;
  error: any;
  openUploadModal: boolean;
  file: any;
  fileUpload: any;
  uploadLoading: boolean;
  selecteditem: any;
  descr: string;
  uploadError: any;
  count: string;
  stock_amount: number;
  debounceTimeout: any;
}

export class TransactionController extends Component<IProps, IState> {
  arrowRef: any;
  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    debounceTimeout: null, 
    clickLoading: false,
    stock_amount: 0,
    count: "",
    shareHolder:this.props.dashboardData?.debit_amount ? this.props.dashboardData?.debit_amount :null,
    str: "",
    anchorEl: null,
    open: false,
    value: "",
    openModal: false,
    openActionModal: false,
    loading: false,
    shareList: [],
    page: 1,
    price: this.props.dashboardData?.debit_share_settlements_price ? this.props.dashboardData?.debit_share_settlements_price : null,
   
    title: "",
    to_date: "",
    number: "",
    plan_type: "",
    error: [],
    openUploadModal: false,
    file: "",
    fileUpload: "",
    uploadLoading: false,
    selecteditem: {},
    descr: "",
    uploadError: [],
  };
  id: any = this.state.open ? "simple-popper" : undefined;

  debounceApiCall = (shareHolder: number) => {
    if (this.state.debounceTimeout) {
      clearTimeout(this.state.debounceTimeout);
    }

    const timeout = setTimeout(() => {
      this.createPreFactor(shareHolder);
    }, 500);

    this.setState({ debounceTimeout: timeout });
  };

  handleChange = (e: any) => {
    this.setState({ value: e.target.value });
  };

  getList = async (): Promise<void> => {
    this.setState({ loading: true });
    const { page, count } = this.state;

    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "10",
    };

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        params.append(key, value);
      }
    }

    try {
      const response = await service.Dashboard.SharesList(params.toString());
      if (response) {
        this.setState({ shareList: response?.data?.data, loading: false });
        // this.setState({ openModal: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
    // this.setState({ openModal: false });
  };

  async create() {
    const { price, shareHolder } = this.state;

    try {
      this.setState({ clickLoading: true });

      const response = await service.Payment.create({
        stock_amount: shareHolder,
        deposit_amount: price,
      });
      if (response) {
        this.setState({ clickLoading: false });
        const redirectUrl = response?.data?.data?.url;  

        if (response.status === 200) {
          toast.success("درخواست شما با موفقیت انجام شد");
          window.location.href = redirectUrl;
        } else {
          toast.error(response?.data?.message);
        }
      } else {
        toast.error(" با خطا مواجه شدید ");
        this.setState({ clickLoading: false });
      }
    } catch (err: any) {
      this.setState({ clickLoading: false });
      this.setState({ error: err?.inner });
      toast.error(err?.data?.message);
    }
  }

  createPreFactor = async (shareHolder: number): Promise<void> => {
    this.setState({ clickLoading: true });

    let parameters = {
      stock_amount: shareHolder ? shareHolder : 0,
    };

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        params.append(key, value.toString());
      }
    }

    try {
      const response = await service.Payment.GetPrice(params);
      if (response) {
        this.setState({
          price: response?.data?.data?.price,
          clickLoading: false,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ clickLoading: false });
    }
  };

  handleChangeShareHolder = (e: any) => {
    const value = e.target.value;
    this.setState({ shareHolder: value });

    this.debounceApiCall(value);
  };

  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value });
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getList();
    }, 800);
  };

  resetTimeOut: string | number | NodeJS.Timeout | undefined;
  resetFilter = () => {
    this.setState({
      to_date: "",
      title: "",
      number: "",
      plan_type: "",
    });

    clearTimeout(this.resetTimeOut);
    this.resetTimeOut = setTimeout(() => {
      this.getList();
    }, 800);
  };

  closeUploadModal = () => {
    this.setState({
      openUploadModal: !this.state.openUploadModal,
      loading: false,
      uploadLoading: false,
      selecteditem: {},
      descr: "",
      fileUpload: "",
      file: "",
      uploadError: [],
      plan_type: "",
    });
  };
}

export default TransactionController;
